import { Toaster as Sonner, toast } from "sonner"

/**
 * Toast/Notification component with proper iOS safe-area support
 * 
 * Key features:
 * - Positioned below iPhone Dynamic Island/notch using env(safe-area-inset-top)
 * - Fixed positioning so it stays visible during scroll
 * - Text wraps properly (2-3 lines max)
 * - HIGH CONTRAST colors (dark background, white text)
 * - Auto-dismisses after 4 seconds
 * - Swipe to dismiss enabled
 * - Centered with proper padding
 */
const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      position="top-center"
      // Offset from top to account for iOS safe area (notch/dynamic island)
      offset="calc(env(safe-area-inset-top, 0px) + 20px)"
      // Gap between stacked toasts
      gap={10}
      // Visible toasts count
      visibleToasts={3}
      // Allow swipe to dismiss (must be plural 'swipeDirections' array for Sonner v2)
      swipeDirections={['up']}
      // Toast options for styling
      toastOptions={{
        // Duration in ms - auto dismiss after 4 seconds
        duration: 4000,
        // Custom class names - CSS in index.css handles actual styling
        classNames: {
          toaster: "",
          toast: "group toast",
          title: "",
          description: "",
          actionButton: "!bg-white !text-slate-900 !font-semibold !rounded-lg !px-4 !py-2 !text-sm",
          cancelButton: "!bg-white/20 !text-white !font-medium !rounded-lg !px-4 !py-2 !text-sm",
          closeButton: "",
        },
      }}
      // Close button for dismissing
      closeButton={true}
      // Rich colors for visibility
      richColors={true}
      {...props}
    />
  );
}

export { Toaster, toast }
